import React from 'react';
import { Shield, Lock, Eye, FileText } from 'lucide-react';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>

          <div className="space-y-8">
            <section>
              <div className="flex items-center mb-4">
                <Shield className="w-6 h-6 text-purple-600 mr-2" />
                <h2 className="text-xl font-semibold">Data Protection</h2>
              </div>
              <p className="text-gray-600">
                We take the protection of your personal data seriously. While we strive to provide accurate
                information through our platform, we are not responsible for any inaccuracies in the
                educational content provided. Users should verify critical information from official sources.
              </p>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <Lock className="w-6 h-6 text-purple-600 mr-2" />
                <h2 className="text-xl font-semibold">Information Security</h2>
              </div>
              <p className="text-gray-600">
                We implement appropriate technical and organizational measures to ensure the security of
                your personal information. However, no internet-based system is 100% secure, and we cannot
                guarantee the security of information transmitted to our platform.
              </p>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <Eye className="w-6 h-6 text-purple-600 mr-2" />
                <h2 className="text-xl font-semibold">Content Disclaimer</h2>
              </div>
              <p className="text-gray-600">
                The educational content, including quizzes and coding challenges, is provided for learning
                purposes only. While we strive for accuracy, we make no warranties about the completeness,
                reliability, or accuracy of this information. Any action you take based on the content
                is strictly at your own risk.
              </p>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <FileText className="w-6 h-6 text-purple-600 mr-2" />
                <h2 className="text-xl font-semibold">Terms of Use</h2>
              </div>
              <p className="text-gray-600">
                By using our platform, you agree to these terms and acknowledge that the learning materials
                are provided "as is" without any guarantees. We reserve the right to modify or discontinue
                any aspect of the service without notice.
              </p>
            </section>
          </div>

          <div className="mt-8 p-4 bg-purple-50 rounded-lg">
            <p className="text-sm text-gray-600">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}